var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-field',{attrs:{"label":"Device","name":"device_id","styles":"width: 140px","placeholder":"-- device -- ","optionStyles":_vm.$vuetify.breakpoint.mdAndUp ? '': 'width:250px',"type":"select","list":_vm.devices,"display":_vm.display}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d5478c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filter/filterFieldDevices.vue
// module id = null
// module chunks = 